import axios from "axios";
import loginResponse from "./loginResponse";

export default async function(email, vueInstance) {
    vueInstance.loading = true;

    await axios
        .post(`${vueInstance.urlPrefix}/api/internal/users/ghost.json`, {
            email,
        }, {
            headers: {'Accept': 'application/vnd.api+json'},
        })
        .then(response => loginResponse(response, vueInstance))
        .catch(() => vueInstance.$emit('error'));

    vueInstance.loading = false;
};



// WEBPACK FOOTER //
// ./src/Assets/components/Users/LoginOrSignup/mixins/createGhost.js